import { PolymerElement, html } from '@polymer/polymer/polymer-element';

class ZuiDialogHeader extends PolymerElement {
  static get properties() {
    return {};
  }

  constructor() {
    super();
  }

  ready() {
    super.ready();
  }

  static get template() {
    return html`
      <style>
        :host > div {
          margin: 5px 0;
        }
        h2 {
          font-size: 1.86rem;
          font-weight: 600;
        }
      </style>
      <div>
        <h2><slot></slot></h2>
      </div>
    `;
  }

}

customElements.define('zui-dialog-header', ZuiDialogHeader);